/**
 * radio eventBus
 * https://alligator.io/vuejs/global-event-bus/
 * 
 * USAGE:
 * // Import the EventBus.
 * import { EventBus } from './eventBus';
 *
 * // Send the event on a channel (i-got-clicked) with a payload (the click count.)
 * EventBus.$emit('i-got-clicked', this.clickCount);
 * 
 * // Listen to the event.
 * EventBus.$on('i-got-clicked', clickHandler);
 * 
 * // Stop listening.
 * EventBus.$off('i-got-clicked', clickHandler);
 * 
 * // Listen for the i-got-clicked event and its payload.
 * EventBus.$on('i-got-clicked', clickCount => {
 *   console.log(`Oh, that's nice. It's gotten ${clickCount} clicks! :)`)
 * });
 */

import Vue from 'vue';

const DoLogs = false;
declare var log;

export const EventBus = new Vue({
  created () {
    //this.$on('my-event', this.handleMyEvent)
    // this.$on('dataPagesReady', (payload) => {
    //   console.log('dataPagesReady', payload);
    // });
  },
  methods: {
    subscribe(channel: string, callback: any = () => {}) {
      log('subscribe', channel);
      this.$on(channel, callback);
      if (DoLogs) {
        this.$on(channel, this.logger);
      }
    },
    unsubscribe(channel: string, callback: any = () => {}) {
      // console.log('unsubscribe', channel);
      this.$off(channel, callback);
    },
    publish(channel: string, payload?: any) {
      log('publish', channel);
      this.$emit(channel, payload);
    },

    logger(payload) {
      console.log('EventBus Logger payload:', payload);
    }

    // handleMyEvent ($event) {
    //   console.log('My event caught in global event bus', $event)
    // }
  }
});
